/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { setupOptions } from '../helper/setup-options.helper';
import { CoreErrorKey } from '../key/core-error.key';
import { CoreFormatterKey } from '../key/core-formatter.key';
import { ApplicationError } from '../model/application-error.model';
import { Formatter } from '../provider/formatter.provider';

export interface JoinFormatterOptions {
  separator?: string;
  nullFormat?: string;
}

export class JoinFormatter implements Formatter {
  protected readonly options: JoinFormatterOptions;

  constructor(options?: JoinFormatterOptions) {
    this.options = JoinFormatter.setupOptions(options);
  }

  format(value: any | any[]): string {
    if (value === undefined || value === null) {
      return this.options.nullFormat === null ? '' : this.options.nullFormat;
    }
    if (typeof value === 'string') {
      return value;
    }
    if (!Array.isArray(value)) {
      return JSON.stringify(value);
    } else if (this.options.nullFormat === null) {
      value = value.filter((item) => item !== undefined && item !== null);
    }
    return value
      .map((item) => {
        if (item === undefined || item === null) {
          item = this.options.nullFormat;
        } else if (typeof item !== 'string') {
          item = JSON.stringify(item);
        }
        return item;
      })
      .join(this.options.separator);
  }

  parse(value: string): any {
    throw new ApplicationError({
      key: CoreErrorKey.NOT_SUPPORTED,
      arguments: { key: CoreFormatterKey.JOIN, operation: 'parse' }
    });
  }

  clone(options: JoinFormatterOptions): JoinFormatter {
    return new JoinFormatter(Object.assign({}, this.options, options));
  }

  static setupOptions(options: JoinFormatterOptions): JoinFormatterOptions {
    try {
      return setupOptions({
        separator: ', ',
        nullFormat: { type: 'string', default: null },
      }, options);
    } catch (error) {
      throw new ApplicationError({
        key: CoreErrorKey.FORMATTER_OPTIONS_INVALID,
        arguments: { formatterKey: CoreFormatterKey.JOIN, options, error },
        message: `Formatter options for '${CoreFormatterKey.JOIN}' invalid`
      });
    }
  }

}

